import React, { useContext, useState } from 'react'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import useMessage from 'App/hooks/useMessage'
import styles from './styles.css'
import renderGenericTextInstructions from './GenericTextInstructions'
import { documentAttach } from './data'
import { Field } from 'simple-react-form'
import DocumentUploadField from 'App/components/DocumentUploadField'
import { useNavigate } from 'react-router-dom'
import { KycContext } from '../Layout'

const ManualVerification = () => {
  const navigate = useNavigate()
  const showMessage = useMessage()
  const [uploadedDocuments, setUploadedDocuments] = useState({})
  const { kyc, updateKyc } = useContext(KycContext)

  const handleDocumentChange = (fieldName, value) => {
    setUploadedDocuments(prev => ({
      ...prev,
      [fieldName]: value,
    }))
  }

  const save = async () => {
    try {
      await updateKyc(kyc.id, {}, uploadedDocuments)
      showMessage('Imágenes almacenadas')
      navigate('../missing-information', {
        state: { missingParameters: ['address', 'fundsOrigin', 'monthlyIncome'] },
      })
    } catch (error) {
      showMessage(error)
    }
  }

  const renderDocumentCol = ({ title, headers, icon, type, cameraOverlay }, index) => (
    <div className={`col-xs-12 col-md-3 ${styles.documentAttachCol}`} key={index}>
      <Field
        title={title}
        headers={headers}
        icon={icon}
        fieldName={type}
        type={DocumentUploadField}
        cameraOverlay={cameraOverlay}
        onChange={value => handleDocumentChange(type, value)}
      />
    </div>
  )

  return (
    <div className={`row ${styles.container}`}>
      <div className={`col-md-10 ${styles.textContainer}`}>
        {renderGenericTextInstructions(
          'Archivos adjuntos',
          'Por regulación del Estado de Chile, debemos conservar una copia de tu documento de identificación y una selfie para efectos de validación.',
        )}
      </div>
      <div className={`row col-md-10 ${styles.container}`}>
        {documentAttach.map((value, index) => renderDocumentCol(value, index))}
      </div>
      <div className="flex w-full items-center justify-center">
        <Button onClick={save} big primary className>
          Enviar
        </Button>
      </div>
    </div>
  )
}

export default ManualVerification
